import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { BETEC_CONTACT } from "./Contacto";
import { trackEvent } from "../lib/analytics";

const PREFILLED =
  "Hola Betec, me gustaría conversar sobre una cotización / soporte.";

export const WhatsAppFloat = () => {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 220);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const link = `https://wa.me/${BETEC_CONTACT.whatsapp}?text=${encodeURIComponent(
    PREFILLED
  )}`;

  return (
    <div
      data-testid="whatsapp-float"
      aria-hidden={!visible}
      className={`fixed z-[60] bottom-5 left-5 md:bottom-6 md:left-6 transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      {/* Tooltip / mini panel */}
      <div
        className={`absolute bottom-[calc(100%+12px)] left-0 w-[260px] rounded-md bg-white shadow-[0_24px_60px_-20px_rgba(10,42,78,0.45)] border border-slate-200 p-4 transition-all duration-300 origin-bottom-left ${
          open
            ? "opacity-100 scale-100 translate-y-0"
            : "opacity-0 scale-95 translate-y-2 pointer-events-none"
        }`}
      >
        <div className="flex items-start justify-between gap-3 mb-2.5">
          <div>
            <div className="text-[10.5px] uppercase tracking-[0.22em] font-mono font-semibold text-[#1FA08A] mb-1">
              Mesa de ayuda Betec
            </div>
            <div className="text-[13.5px] font-semibold text-[#0A2A4E] leading-snug">
              ¿Necesitas asistencia ahora?
            </div>
          </div>
          <button
            type="button"
            onClick={() => setOpen(false)}
            aria-label="Cerrar"
            className="w-6 h-6 inline-flex items-center justify-center text-slate-400 hover:text-slate-700"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
        <p className="text-[12.5px] text-slate-600 leading-relaxed mb-3">
          Escríbenos por WhatsApp y un especialista te responderá.
        </p>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-cta"
          onClick={() => trackEvent("whatsapp_click", { location: "floating-panel" })}
          className="inline-flex items-center justify-center w-full gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white px-4 py-2.5 rounded-sm text-[13px] font-semibold tracking-wide transition-colors"
        >
          <MessageCircle className="w-4 h-4" />
          Abrir WhatsApp
        </a>
      </div>

      {/* Floating button */}
      <button
        type="button"
        data-testid="whatsapp-toggle"
        onClick={() => {
          const next = !open;
          setOpen(next);
          if (next) trackEvent("whatsapp_click", { location: "floating-button" });
        }}
        aria-label="WhatsApp Betec"
        className="relative group inline-flex items-center justify-center w-14 h-14 md:w-15 md:h-15 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white shadow-[0_14px_40px_-10px_rgba(37,211,102,0.6)] hover:shadow-[0_20px_50px_-10px_rgba(37,211,102,0.8)] transition-all duration-300 hover:-translate-y-0.5"
      >
        <span
          aria-hidden
          className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40"
          style={{ animationDuration: "2.4s" }}
        />
        <MessageCircle className="relative w-6 h-6" strokeWidth={2} />
      </button>
    </div>
  );
};

export default WhatsAppFloat;
